 const wrapper_s = document.querySelector(".video_thumbnail_images .video-wrapper_s");
    const iframe_s = document.querySelector(".video_thumbnail_images #ytVideo");

    if (wrapper_s && iframe_s) {
        wrapper_s.addEventListener("click", function () {

            // Hide thumbnail
            wrapper_s.style.display = "none";

            // Show iframe (video already has autoplay)
            iframe_s.style.display = "block";
        });
    }